// @LTG-ID: F-022
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 07_PAGES_AND_ROUTES.md#layout-chrome, 08_FEATURES.md#F-022
// @CHANGED: 2026-02 session_001
// @OWNER: web
//
// Footer — full sitemap + compliance + legal.
// Visual reference: /app/source_reference/Landing Page.html lines 3023-3101.
// All <a> targets are taken verbatim from the source bundle.

import { Link } from "react-router-dom";
import "./footer.css";

export const Footer = () => {
    return (
        <footer className="ltg-footer" data-testid="site-footer">
            <div className="ltg-footer__container">
                <div className="ltg-footer__grid">
                    <div className="ltg-footer__brand">
                        <img
                            src="/assets/logo-bubble.png"
                            alt=""
                            className="ltg-footer__bubble"
                        />
                        <img
                            src="/assets/logo-wordmark.png"
                            alt="KGOB CPAs and Advisors"
                            className="ltg-footer__wordmark"
                        />
                        <p>
                            Full-service CPA and advisory practice serving
                            owners, operators and professionals in all 50
                            states from offices across North Carolina.
                            <br />
                            <br />
                            <span className="ltg-footer__slogan">
                                Luxury Advisory · Precision Compliance
                            </span>
                        </p>
                    </div>

                    <div className="ltg-footer__col">
                        <h5>Services</h5>
                        <ul>
                            <li>
                                <Link
                                    to="/#engage"
                                    data-testid="footer-link-tax"
                                >
                                    Tax preparation and planning
                                </Link>
                            </li>
                            <li>
                                <a
                                    href="https://kgob.com/services/irs-relief"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="footer-link-irs"
                                >
                                    IRS resolution
                                </a>
                            </li>
                            <li>
                                <Link
                                    to="/#engage"
                                    data-testid="footer-link-advisory"
                                >
                                    Bookkeeping and advisory
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/#snapshot"
                                    data-testid="footer-link-snapshot"
                                >
                                    Business valuations
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/#exit"
                                    data-testid="footer-link-entity"
                                >
                                    Entity work and succession
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="ltg-footer__col">
                        <h5>Read</h5>
                        <ul>
                            <li>
                                <Link
                                    to="/journals"
                                    data-testid="footer-link-journals"
                                >
                                    The KGOB Journals
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/journals/what-is-my-business-worth"
                                    data-testid="footer-link-brief-01"
                                >
                                    What is my business worth?
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/journals#sector"
                                    data-testid="footer-link-sector"
                                >
                                    Sector deep-dives
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/journals#exit"
                                    data-testid="footer-link-exit"
                                >
                                    Exit planning
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/journals#deals"
                                    data-testid="footer-link-deals"
                                >
                                    Deal structures and tax
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/contact"
                                    data-testid="footer-link-contact"
                                >
                                    <strong>Contact us</strong>
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="ltg-footer__col">
                        <h5>Reach</h5>
                        <ul>
                            <li>Headquartered in Charlotte, NC</li>
                            <li>Additional offices across NC</li>
                            <li>Clients in all 50 states</li>
                            <li>Remote and on-site engagements</li>
                        </ul>
                    </div>

                    <div className="ltg-footer__col">
                        <h5>Contact</h5>
                        <ul>
                            <li>2740 East W.T. Harris Blvd,</li>
                            <li>Suite 200, Charlotte, NC 28213</li>
                            <li>
                                <a
                                    href="tel:+17045993355"
                                    data-testid="footer-link-phone"
                                >
                                    (704) 599-3355
                                </a>
                            </li>
                            <li>
                                <a
                                    href="mailto:support@letstalkgrowth.com"
                                    data-testid="footer-link-email"
                                >
                                    support@letstalkgrowth.com
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.linkedin.com/company/kgobcpa"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="footer-link-linkedin"
                                >
                                    LinkedIn · @kgobcpa
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.instagram.com/kgobcpa/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="footer-link-instagram"
                                >
                                    Instagram · @kgobcpa
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="ltg-footer__compliance">
                    <p>
                        Let's Talk Growth is a tool published by KGOB CPAs and
                        Advisors (Kohari Gonzalez Oneyear and Brown PLLC), 2740
                        East W.T. Harris Blvd, Suite 200, Charlotte, NC 28213.
                        For product support, email{" "}
                        <a
                            href="mailto:support@letstalkgrowth.com"
                            data-testid="footer-compliance-support-email"
                        >
                            support@letstalkgrowth.com
                        </a>
                        . For CPA firm inquiries, reach KGOB at{" "}
                        <a
                            href="mailto:connect@kgob.com"
                            data-testid="footer-compliance-firm-email"
                        >
                            connect@kgob.com
                        </a>{" "}
                        or <a href="tel:+17045993355">(704) 599-3355</a>.
                    </p>
                    <p>
                        Indicative valuation only. <strong>Not</strong> a
                        formal business appraisal under USPAP, the AICPA
                        Statement on Standards for Valuation Services (SSVS
                        No.&nbsp;1), or any state appraiser-licensing regime.
                        Not investment, legal, or tax advice. For appraisal,
                        tax, or attest engagements, engage KGOB directly. KGOB
                        is licensed in North Carolina; for state-specific tax,
                        regulatory, or appraisal matters, engage a CPA or
                        appraiser licensed in your jurisdiction.
                    </p>
                </div>

                <div className="ltg-footer__legal" data-testid="footer-legal">
                    <Link
                        to="/refund-policy"
                        data-testid="footer-legal-refund"
                    >
                        Refund Policy
                    </Link>
                    <a
                        href="https://kgob.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-legal-tos"
                    >
                        Terms of Service
                    </a>
                    <a
                        href="https://kgob.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-legal-privacy"
                    >
                        Privacy Policy
                    </a>
                    <Link
                        to="/refund-policy#disclaimer"
                        data-testid="footer-legal-disclaimer"
                    >
                        Indicative Valuation Disclaimer
                    </Link>
                    <a
                        href="https://nccpaboard.gov"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-legal-ncboard"
                    >
                        Professional Conduct · NC State Board
                    </a>
                </div>

                <div className="ltg-footer__bottom" data-testid="footer-bottom">
                    <span>
                        © 2026 KGOB CPAs and Advisors · Luxury Advisory ·
                        Precision Compliance
                    </span>
                    <span>
                        NC CPA firm registration on file · NC State Board of
                        CPA Examiners
                    </span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
